import { render, staticRenderFns } from "./modal-event-card.vue?vue&type=template&id=5691f4b0"
import script from "./modal-event-card.vue?vue&type=script&lang=js"
export * from "./modal-event-card.vue?vue&type=script&lang=js"
import style0 from "./modal-event-card.vue?vue&type=style&index=0&id=5691f4b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports